<div *ngIf="carousels.length > 0" id="lifeiqCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel">
  <div *ngIf="!landing" class="carousel-indicators">
    <button *ngFor="let carousel of carousels; let i = index" 
            type="button" 
            [class]="!carousel.first ? 'carousel-menu' : 'carousel-menu active'" 
            [attr.data-bs-target]="'#lifeiqCarousel'"
            [attr.data-bs-slide-to]="i"
            [attr.aria-current]="carousel.first ? 'true' : null"
            [attr.aria-label]="'Slide ' + (i + 1)"></button>
  </div>
  <div class="carousel-inner">
    <div *ngFor="let carousel of carousels" (click)="landing ? '' : openCarousel(carousel)" [ngClass]="[!carousel.first ? 'carousel-item' : 'carousel-item active', landing ? '' : 'overlay']">
      <div class="img-carousel-div item">
        <img class="carousel-image" [src]="landing ? carousel.chosenImage : getCarouselImage(carousel.chosenImage)" alt="...">
      </div>
      <div *ngIf="carousel.title && carousel.description != ''" class="carousel-caption">
        <h1>{{ carousel.title | uppercase }}</h1>
        <p>{{ carousel.description }}</p>
      </div>
    </div>
  </div>
  <button *ngIf="!landing" class="carousel-control-prev" type="button" data-bs-target="#lifeiqCarousel" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button *ngIf="!landing" class="carousel-control-next" type="button" data-bs-target="#lifeiqCarousel" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
